var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExplore1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "explore 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.172 18.2017C45.711 20.1087 46 22.1217 46 24.2017C46 36.3517 36.15 46.2017 24 46.2017C11.85 46.2017 2 36.3517 2 24.2017C2 12.0517 11.85 2.20166 24 2.20166C28.651 2.20166 33.018 3.67666 36.572 6.13966",
    stroke: "#9F795C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 37.2017C31.1797 37.2017 37 31.3814 37 24.2017C37 17.022 31.1797 11.2017 24 11.2017C16.8203 11.2017 11 17.022 11 24.2017C11 31.3814 16.8203 37.2017 24 37.2017Z",
    stroke: "#9F795C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24 28.2017C26.2091 28.2017 28 26.4108 28 24.2017C28 21.9925 26.2091 20.2017 24 20.2017C21.7909 20.2017 20 21.9925 20 24.2017C20 26.4108 21.7909 28.2017 24 28.2017Z",
    stroke: "#9F795C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40 12.2017C42.2091 12.2017 44 10.4108 44 8.20166C44 5.99252 42.2091 4.20166 40 4.20166C37.7909 4.20166 36 5.99252 36 8.20166C36 10.4108 37.7909 12.2017 40 12.2017Z",
    stroke: "#9F795C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore1);
export default __webpack_public_path__ + "static/media/explore 1.748aeb4c3df2acc3ca8ae4bdbe852bac.svg";
export { ForwardRef as ReactComponent };